/**
 * The Widget Builder's two tabs (CT-5190, restructured 2026-09-08).
 *
 * The three-step stepper is gone. From the 2026-09-08 sync: the third step was
 * dropped for scalability, and the remaining two are a **Switch Tab**, not a
 * wizard — _"lo dejé con switch tab para poder así navegar entre la información
 * y tampoco tener muchos scrollers unificando todo en un solo paso"_.
 *
 * They are freely navigable: unlike the old stepper there is no per-tab lock,
 * because a tab is a view of the same form, not a gate. What still gates is the
 * **save**, on a widget name (`useWidgetBuilderForm.canSave`).
 */
export const WIDGET_BUILDER_TABS = Object.freeze([
  Object.freeze({ id: 'data', labelKey: 'widgetBuilder.tabs.data' }),
  Object.freeze({ id: 'configure', labelKey: 'widgetBuilder.tabs.configure' }),
]);

/** The tab the builder opens on. */
export const FIRST_WIDGET_BUILDER_TAB = WIDGET_BUILDER_TABS[0].id;

export default WIDGET_BUILDER_TABS;
